"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var at_1 = __importDefault(require("sportnet-utilities/lib/at"));
var removeAccents_1 = __importDefault(require("sportnet-utilities/lib/removeAccents"));
var utilities_1 = require("../utilities");
var Options_1 = require("./Options");
function isOptionSelected(option, value) {
    if (Array.isArray(value)) {
        return !!value.find(function (v) {
            return v.value === option.value;
        });
    }
    else if (value) {
        return value.value === option.value;
    }
    return false;
}
exports.isOptionSelected = isOptionSelected;
function getDefaultCreateOption(inputValue) {
    return {
        value: Options_1.CREATE_OPTION_VALUE,
        label: utilities_1.__('Vytvoriť novú možnosť') + " \"" + inputValue + "\"",
    };
}
exports.getDefaultCreateOption = getDefaultCreateOption;
function containsExactMatch(options, inputValue) {
    return options.findIndex(function (option) { return String(option.value) === inputValue; }) > -1;
}
exports.containsExactMatch = containsExactMatch;
exports.defaultFilterFunction = function (option, inputValue) {
    var haystack = removeAccents_1.default(String(option.label)).toLowerCase() + " " + removeAccents_1.default(String(option.value)).toLowerCase();
    return haystack.indexOf(removeAccents_1.default(inputValue).toLowerCase()) > -1;
};
exports.defaultFilterOptions = function (options, inputValue) {
    return options.filter(function (option) { return exports.defaultFilterFunction(option, inputValue); });
};
function isMultiple(value, multiple) {
    return multiple;
}
function useTheSelectOptions(items, formatOption, value, deps, _a) {
    var _b = (_a === void 0 ? {} : _a).multiple, multiple = _b === void 0 ? false : _b;
    var _c = react_1.default.useState([]), options = _c[0], setOptions = _c[1];
    var _d = react_1.default.useState({}), optionsByValue = _d[0], setOptionsByValue = _d[1];
    react_1.default.useEffect(function () {
        var newOptionsByValue = {};
        var newOptions = items.map(function (unformattedOption) {
            var formattedOption = formatOption(unformattedOption);
            newOptionsByValue[String(formattedOption.value)] = formattedOption;
            return formattedOption;
        });
        setOptions(newOptions);
        setOptionsByValue(newOptionsByValue);
    }, deps); // eslint-disable-line react-hooks/exhaustive-deps
    var selectedOption = react_1.default.useMemo(function () {
        if (isMultiple(value, !!multiple)) {
            return at_1.default(optionsByValue, value.map(String));
        }
        var stringValue = String(value);
        return stringValue in optionsByValue ? optionsByValue[stringValue] : null;
    }, [optionsByValue, value, multiple]);
    return [options, selectedOption, optionsByValue];
}
exports.useTheSelectOptions = useTheSelectOptions;
